import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { logOut } from '../actions/user';

export default function PanelAccessDenied() {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    return (
        <div role="alert">
            <p>{t('error.no_access_to_fetch')}</p>
            <button onClick={() => dispatch(logOut())}>{t('header.change_user')}</button>
        </div>
    );
}
